const VendorActions = {
    UPDATE_SERVICES: 'UPDATE_SERVICES',
    UPDATE_USER: 'UPDATE_USER',
    UPDATE_VACATION: 'UPDATE_VACATION'
}

export default VendorActions;